import axios from 'axios';
import {
    START_SESSION_REQUEST,
    START_SESSION_SUCCESS,
    START_SESSION_FAIL,
    END_SESSION_REQUEST,
    END_SESSION_SUCCESS,
    END_SESSION_FAIL,
    GET_ACTIVE_SESSION_REQUEST,
    GET_ACTIVE_SESSION_SUCCESS,
    GET_ACTIVE_SESSION_FAIL,
    GET_SESSION_SUMMARY_REQUEST,
    GET_SESSION_SUMMARY_SUCCESS,
    GET_SESSION_SUMMARY_FAIL,
} from '../constants/sessionConstants';

const baseUrl = process.env.REACT_APP_API_URL;

// ============================================================================
// HELPER: Get auth config from state
// ============================================================================
const getAuthConfig = (getState) => {
    const { userLogin, adminLogin } = getState();
    const userInfo = userLogin?.userInfo || adminLogin?.userInfo;

    if (!userInfo?.token) {
        throw new Error('Not authenticated');
    }

    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
        },
    };
};

// ============================================================================
// START PLAYER SESSION
// ============================================================================
export const startPlayerSession = (playerId, clubId) => async (dispatch, getState) => {
    try {
        dispatch({ type: START_SESSION_REQUEST });

        const config = getAuthConfig(getState);
        const { data } = await axios.post(
            `${baseUrl}/players/${playerId}/sessions/start`,
            { clubId },
            config
        );

        dispatch({
            type: START_SESSION_SUCCESS,
            payload: data.session,
        });

        return data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to start session';
        dispatch({
            type: START_SESSION_FAIL,
            payload: message,
        });
        throw new Error(message);
    }
};

// ============================================================================
// END PLAYER SESSION
// ============================================================================
export const endPlayerSession = (playerId, clubId = null) => async (dispatch, getState) => {
    try {
        dispatch({ type: END_SESSION_REQUEST });

        const config = getAuthConfig(getState);
        const body = clubId ? { clubId } : {};
        const { data } = await axios.post(
            `${baseUrl}/players/${playerId}/sessions/end`,
            body,
            config
        );

        dispatch({
            type: END_SESSION_SUCCESS,
            payload: data.session,
        });

        return data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to end session';
        dispatch({
            type: END_SESSION_FAIL,
            payload: message,
        });
        throw new Error(message);
    }
};

// ============================================================================
// GET ACTIVE SESSION
// ============================================================================
export const getActivePlayerSession = (playerId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_ACTIVE_SESSION_REQUEST });

        const config = getAuthConfig(getState);
        const { data } = await axios.get(
            `${baseUrl}/players/${playerId}/sessions/active`,
            config
        );

        dispatch({
            type: GET_ACTIVE_SESSION_SUCCESS,
            payload: data.activeSession,
        });

        return data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to get active session';
        dispatch({
            type: GET_ACTIVE_SESSION_FAIL,
            payload: message,
        });
        throw new Error(message);
    }
};

// ============================================================================
// GET SESSION SUMMARY
// ============================================================================
export const getPlayerSessionSummary = (playerId) => async (dispatch, getState) => {
    try {
        dispatch({ type: GET_SESSION_SUMMARY_REQUEST });

        const config = getAuthConfig(getState);
        const { data } = await axios.get(
            `${baseUrl}/players/${playerId}/sessions/summary`,
            config
        );

        dispatch({
            type: GET_SESSION_SUMMARY_SUCCESS,
            payload: data,
        });

        return data;
    } catch (error) {
        const message = error.response?.data?.message || error.message || 'Failed to get session summary';
        dispatch({
            type: GET_SESSION_SUMMARY_FAIL,
            payload: message,
        });
        throw new Error(message);
    }
};
